import { readToken } from '@app/services/localStorage.service';
import axios, { AxiosError } from 'axios';

interface Error {
  message: string[];
  statusCode: number;
}

export const httpApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

httpApi.interceptors.request.use(
  (config) => {
    const token = readToken();
    if (config && config.headers) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

httpApi.interceptors.response.use(undefined, (error: AxiosError<Error>) => {
  error['name'] = error?.response?.statusText || '';
  error['code'] = error?.response?.status.toString() || '';
  error['message'] = error?.response?.data?.message
    ? error?.response?.data?.message.toString()
    : error?.response?.data.toString() || '';
  error['response'] = error?.response;
  return Promise.reject(error);
});

export interface ApiErrorData {
  message: string;
}
